import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@getgreenline/blaze-ui";
import { ssoClient, ssoEnabled } from "../../lib/sso-client";
import { useAuthStore } from "../../stores/auth-store";

export function LoginPage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const loginTriggered = useRef(false);

  useEffect(() => {
    if (!ssoEnabled || isAuthenticated || loginTriggered.current) return;
    loginTriggered.current = true;
    ssoClient?.login();
  }, [isAuthenticated]);

  if (!ssoEnabled || isAuthenticated) {
    return <Navigate to="/campaigns" replace />;
  }

  return (
    <div className="tw:flex tw:h-screen tw:items-center tw:justify-center">
      <Spinner className="tw:h-8 tw:w-8 tw:text-muted-foreground" />
    </div>
  );
}
